import React from 'react';
import { Route, useRouteMatch } from 'react-router-dom';
import useAuth from '../../../auth/useAuth';
import AccessDenied from '../../Util/AccessDenied';
import HubSettingsPage from './HubSettings/HubSettingsPage';
import DashboardTasksRouter from './DashboardTasks/DashboardTasksRouter';
import DashboardAdvisorsRouter from './DashboardAdvisors/DashboardAdvisorsRouter';
import CallToActionRouter from './CallToAction/CallToActionRouter';
import DeactivateCobrand from './DeactivateCobrand/DeactivateCobrand';
import Featured from './Featured/Featured';
import CobrandLauncher from './CobrandLauncher/CobrandLauncher';
import CobrandTagsRouter from "./CobrandTags/CobrandTagsRouter";
import CustomDomainRouter from './CustomDomains/CustomDomainRouter';
import DisclaimerMessageRouter from './DisclaimerMessage/DisclaimerMessageRouter';
import MonthlyTasksRouter from './MonthlyTasks/MonthlyTasksRouter';
import AlternateMonthlyTasksRouter from './AlternateMonthlyTasks/AlternateMonthlyTasksRouter'
import BulkUnitUpload from './BulkUnitUpload';
import BenefitsPage from './Benefits/BenefitsPage';
import EmailCourseCompletions from './EmailCourseCompletions/EmailCourseCompletions';
import TeamsSettings from './Teams/TeamsSettings';
import ClientConsoleReportsPage from './ClientConsoleReports/ClientConsoleReportsPage';
import ContentApiSettings from './ContentApi/ContentApiSettings';
import FeaturedSwapTool from './FeaturedSwapTool/FeaturedSwapTool';
import SsoManagementPage from './SsoManagement/SsoManagementPage';
import CustomPoliciesRouter from './CustomPolicies/CustomPoliciesRouter';

const CoBrandSettingsPage = () => {
    let { path } = useRouteMatch();
    const { isAdmin } = useAuth();

    return (
        <div>
            <Route path={`${path}/hub-settings`}>
                <HubSettingsPage />
            </Route>
            <Route path={`${path}/dashboard-tasks`}>
                <DashboardTasksRouter />
            </Route>
            <Route path={`${path}/dashboard-cta`}>
                <DashboardAdvisorsRouter />
            </Route>
            <Route path={`${path}/call-to-action`}>
                <CallToActionRouter />
            </Route>
            <Route path={`${path}/deactivate-cobrand`}>
                <DeactivateCobrand />
            </Route>
            <Route path={`${path}/featured`}>
                <Featured />
            </Route>
            <Route path={`${path}/masked-domains`}>
                <CustomDomainRouter />
            </Route>
            <Route path={`${path}/sso-management`}>
                {isAdmin ? <SsoManagementPage /> : <AccessDenied />}
            </Route>
            <Route path={`${path}/cobrand-launcher`}>
                <CobrandLauncher />
            </Route>
            <Route path={`${path}/bulk-unit-upload`}>
                <BulkUnitUpload /> 
            </Route>        
            <Route path={`${path}/cobrand-tags`}>
                <CobrandTagsRouter />
            </Route>
            <Route path={`${path}/disclaimer-message`}>
                <DisclaimerMessageRouter />
            </Route>
            <Route path={`${path}/monthly-tasks`}>
                <MonthlyTasksRouter />
            </Route>
            <Route path={`${path}/alternate-monthly-tasks`}>
                <AlternateMonthlyTasksRouter />
            </Route>
            <Route path={`${path}/benefits`}>
                <BenefitsPage />
            </Route>
            <Route path={`${path}/client-console-reports`}>
                <ClientConsoleReportsPage />
            </Route>
            <Route path={`${path}/email-course-completions`}>
                <EmailCourseCompletions />
            </Route>
            <Route path={`${path}/teams`}>
                <TeamsSettings />
            </Route>
            <Route path={`${path}/content-api`}>
                <ContentApiSettings />
            </Route>
            <Route path={`${path}/featured-swap`}>
                <FeaturedSwapTool />
            </Route>
            <Route path={`${path}/custom-policies`}>
                <CustomPoliciesRouter />
            </Route>
        </div>
    );
};

export default CoBrandSettingsPage;
